const SELECTOR = "[data-tw-compare-table]";
/** Smooth `scrollBy` for ~286px is ~300–400ms in most browsers; lock slightly longer to avoid stacked scrolls. */
const SCROLL_STEP_COOLDOWN_MS = 480;

function getProductColumnStepWidth(scroll: HTMLElement): number {
  const firstProductColumn = scroll.querySelector<HTMLElement>('thead tr th[data-tw-compare-column="product"]');
  if (!firstProductColumn) return 1;

  return Math.max(1, Math.round(firstProductColumn.getBoundingClientRect().width));
}

function initCompareTable(root: ParentNode = document) {
  const sections = Array.from(root.querySelectorAll<HTMLElement>(SELECTOR));
  for (const section of sections) {
    if (section.dataset.initialized === "true") continue;
    section.dataset.initialized = "true";
    setupSection(section);
  }
}

function setupSection(section: HTMLElement) {
  const sectionId = section.dataset.sectionId || "";
  const parent = section.closest("section") || section.parentElement || document;
  const scroll = section.querySelector<HTMLElement>(`#tw-compare-scroll-${sectionId}`);
  const nav = section.querySelector<HTMLElement>("[data-tw-compare-nav]");
  const leftBtn = parent.querySelector<HTMLButtonElement>(`#tw-compare-left-${sectionId}`);
  const rightBtn = parent.querySelector<HTMLButtonElement>(`#tw-compare-right-${sectionId}`);

  if (!scroll || !leftBtn || !rightBtn) return;

  let scrollStepLocked = false;

  /** ≤2 products: CSS hides mobile nav; skip toggling `hidden` so overflow false-positives never show it. */
  const mobileNavAlwaysHidden = section.dataset.compareFitMobile !== undefined;

  /** Subpixel / rounding tolerance so we do not show scroll UI when everything fits. */
  const OVERFLOW_EPSILON_PX = 4;

  const updateArrows = () => {
    if (scrollStepLocked) return;

    const hasHorizontalOverflow =
      scroll.scrollWidth > scroll.clientWidth + OVERFLOW_EPSILON_PX;

    if (nav && !mobileNavAlwaysHidden) {
      nav.classList.toggle("hidden", !hasHorizontalOverflow);
    }

    const canScrollLeft = scroll.scrollLeft > OVERFLOW_EPSILON_PX;
    const canScrollRight =
      scroll.scrollLeft + scroll.clientWidth <
      scroll.scrollWidth - OVERFLOW_EPSILON_PX;

    leftBtn.disabled = !canScrollLeft;
    rightBtn.disabled = !canScrollRight;
  };

  const runScrollStep = (direction: -1 | 1) => {
    if (scrollStepLocked) return;

    const stepWidth = getProductColumnStepWidth(scroll);
    const delta = direction * stepWidth;

    scrollStepLocked = true;
    leftBtn.disabled = true;
    rightBtn.disabled = true;
    scroll.scrollBy({ left: delta, behavior: "smooth" });

    window.setTimeout(() => {
      scrollStepLocked = false;
      updateArrows();
    }, SCROLL_STEP_COOLDOWN_MS);
  };

  leftBtn.addEventListener("click", () => {
    runScrollStep(-1);
  });

  rightBtn.addEventListener("click", () => {
    runScrollStep(1);
  });

  scroll.addEventListener("scroll", updateArrows, { passive: true });
  window.addEventListener("resize", updateArrows);

  updateArrows();
}

export { initCompareTable };
